import { FC } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { CultureAIGenerateFormData } from './culture-ai-generate.schema';

interface CultureAIGenerateFormProps {
  control: Control<CultureAIGenerateFormData>;
  errors: FieldErrors<CultureAIGenerateFormData>;
  isLoading: boolean;
}

const CultureAIGenerateForm: FC<CultureAIGenerateFormProps> = ({ control, errors, isLoading }) => {
  return (
    <>
      <div>
        <label htmlFor="desired_values" className="block text-sm font-medium text-gray-700 mb-2">
          Desired Values <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="desired_values"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="desired_values"
              rows={3}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.desired_values ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="e.g., Integritas, kolaborasi, inovasi, keberlanjutan"
              disabled={isLoading}
            />
          )}
        />
        {errors.desired_values && <p className="text-sm text-red-500 mt-1">{errors.desired_values.message}</p>}
        <p className="text-xs text-gray-500 mt-1">
          Berisi nilai-nilai yang ingin dijunjung perusahaan. Contoh: "Integritas, kolaborasi, inovasi, keberlanjutan."
        </p>
      </div>

      <div>
        <label htmlFor="work_environment" className="block text-sm font-medium text-gray-700 mb-2">
          Work Environment <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="work_environment"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="work_environment"
              rows={3}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.work_environment ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="e.g., Lingkungan kerja yang suportif, transparan, dan adaptif"
              disabled={isLoading}
            />
          )}
        />
        {errors.work_environment && <p className="text-sm text-red-500 mt-1">{errors.work_environment.message}</p>}
        <p className="text-xs text-gray-500 mt-1">
          Menjelaskan lingkungan kerja yang diinginkan. Contoh: "Lingkungan kerja yang suportif, transparan, dan
          adaptif."
        </p>
      </div>

      <div>
        <label htmlFor="team_characteristics" className="block text-sm font-medium text-gray-700 mb-2">
          Team Characteristics <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="team_characteristics"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="team_characteristics"
              rows={3}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.team_characteristics ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="e.g., Tim yang proaktif, komunikatif, dan mampu bekerja lintas fungsi"
              disabled={isLoading}
            />
          )}
        />
        {errors.team_characteristics && (
          <p className="text-sm text-red-500 mt-1">{errors.team_characteristics.message}</p>
        )}
        <p className="text-xs text-gray-500 mt-1">
          Berisi ciri-ciri tim ideal. Contoh: "Tim yang proaktif, komunikatif, dan mampu bekerja lintas fungsi."
        </p>
      </div>

      <div>
        <label htmlFor="leadership_style" className="block text-sm font-medium text-gray-700 mb-2">
          Leadership Style <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="leadership_style"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="leadership_style"
              rows={3}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.leadership_style ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="e.g., Kepemimpinan yang memberdayakan dan berbasis keteladanan"
              disabled={isLoading}
            />
          )}
        />
        {errors.leadership_style && <p className="text-sm text-red-500 mt-1">{errors.leadership_style.message}</p>}
        <p className="text-xs text-gray-500 mt-1">
          Gaya kepemimpinan yang ingin diterapkan. Contoh: "Kepemimpinan yang memberdayakan dan berbasis keteladanan."
        </p>
      </div>
    </>
  );
};

export default CultureAIGenerateForm;
